import { Injectable, inject } from '@angular/core';

import { WINDOW } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class CssSupportService {
    private cssSupports: (feature: string, value: string) => boolean;
    private readonly _window = inject(WINDOW);

    constructor() {
        this.cssSupports = this._window['CSS'] && this._window['CSS'].supports;
    }

    isFeatureSupported(feature: string, value: string): boolean {
        if (!this.cssSupports) {
            return false;
        }

        return this.cssSupports(feature, value);
    }

    isTouchActionSupported(): boolean {
        return this.isFeatureSupported('touch-action', 'pan-y');
    }
}
